export default function HiddenMotionVisual() {
  return <div>hidden motion works</div>;
}